import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllPersons } from './PersonStore';
import { getAllTeams } from './TeamStore';
import { getAllColors, getAllPlans } from './PlannedItemStore';
import { getAllDocuments } from './DocumentStore';
import { getAllocatedUnits } from './AllocatedUnitStore';
import { getAllUnits, getAllBookings } from './ResourceStore';
import { getFutureEvents } from './EventStore';
import { getNews as getDrNews } from './DrNewsStore';
import { getNews as getLorryNews } from './LorryNewsStore';
import { getFreeText } from './FreeTextStore';
import { getAllRoutes, getAllWinterDuties } from './WinterDutyStore';
import { getSlideShow } from './SlideStore';
import { getAllDevices } from './DeviceStore';

export const reducerName = 'appState';

export const refreshFast = createAsyncThunk(
    'app/refreshFast',
    async (_, { dispatch }) => {
        await Promise.all([
            dispatch(getAllPersons()),
            dispatch(getAllTeams()),
            dispatch(getAllColors()),
            dispatch(getAllPlans()),
            dispatch(getAllDocuments()),
            dispatch(getAllUnits()),
            dispatch(getAllBookings()),
            dispatch(getFutureEvents()),
            dispatch(getDrNews()),
            dispatch(getLorryNews()),
            dispatch(getFreeText()),
            dispatch(getAllocatedUnits()),
            dispatch(getSlideShow(3)),
            dispatch(getSlideShow(4)),
            dispatch(getAllWinterDuties()),
            dispatch(getAllRoutes()),
        ]);
    }
);

export const refreshSlow = createAsyncThunk(
    'app/refreshSlow',
    async (_, { dispatch }) => {
        await dispatch(getAllDevices());
    }
);

const initialState = {
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
};

// Slice definition
const appSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // refreshFast
            .addCase(refreshFast.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(refreshFast.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(refreshFast.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            })
            // refreshSlow
            .addCase(refreshSlow.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(refreshSlow.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(refreshSlow.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default appSlice.reducer;